import React, {useState, useEffect, useContext} from 'react';
import CommandsContext from '../../context/commandsContext';
import useKeyPress from '../../hooks/useKeyPress';
import FullBodyContentView from '../views/fullBodyContentView';

function DeviceInfo({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft: onExit});
    });
  }, [onExit]);

  return (
    <FullBodyContentView
      title="Device Information"
      fullCaption="Tag.......................0x19, 0x4B.......... 
      Device Type.........DEV_5700...........
      Serial Number......0..........................
      Model Code Base............................
      None......................'N','O','M'........... 
      Model Code Options........................
      None......................'N','O','M'........... 
      "
    />
  );
}

export default DeviceInfo;
